import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel, Keyboard } from 'swiper';
import { formatImage } from '@ifeng-fe/public_method';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const DramaGags = ({ content, dramaGagsTitleImage }) => {
    const swiperRef = useRef();

    return (
        <div className={styles.dramaGags}>
            <Chip id="260724" title="剧照花絮专区标题图" groupName="中国力量" type="struct">
                <div className={styles.dramaGagsTitle}>
                    <img className={styles.dramaGagsTitle} src={dramaGagsTitleImage} />
                </div>
            </Chip>
            <div className={styles.banner}>banner</div>
            <Chip id="287972" title="剧照花絮专区" groupName="中国力量" type="recommend">
                <div className={styles.dramaGagsSwiper}>
                    <Swiper
                        modules={[Navigation, Mousewheel, Keyboard]}
                        speed={300}
                        slidesPerView={1}
                        spaceBetween={26}
                        allowTouchMove={false}
                        loop
                        navigation={{ prevEl: `.${styles.prevBox}`, nextEl: `.${styles.nextBox}` }}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}>
                        {content.map((item, index) => {
                            const imageList = item?.intelligentImages?.image.length >= 6 ? item?.intelligentImages?.image : item?.thumbnails?.image || [];

                            if (imageList.lenght < 6) {
                                return null;
                            } else {
                                return (
                                    <SwiperSlide key={index}>
                                        <div className={styles.dramaGagsSwiperSlide}>
                                            <div className={styles.dramaGagsImageBox}>
                                                {imageList.map((imageItem, imageIndex) => {
                                                    return (
                                                        <a href={`${item.url}#p=${imageIndex + 1}`} key={imageIndex} rel="noreferrer" target="_blank">
                                                            <img key={imageItem.url} className={styles.dramaGagsSwiperPic} src={formatImage(imageItem.url, 320, 214)} />
                                                        </a>
                                                    );
                                                })}
                                            </div>
                                            <div className={styles.dramaGagsText}>{item.title}</div>
                                        </div>
                                    </SwiperSlide>
                                );
                            }
                        })}
                    </Swiper>
                    {content.length > 1 && (
                        <>
                            <div className={styles.prevBox}>
                                <img className={styles.prev} src="https://x0.ifengimg.com/ucms/2023_37/E72CAF43C3C7064F67581A81080D5D84E0D7BAEC_size5_w30_h80.png" alt="" />
                            </div>
                            <div className={styles.nextBox}>
                                <img className={styles.next} src="https://x0.ifengimg.com/ucms/2023_37/BD80592C08000F5C843AF2B56719151973C59207_size5_w30_h80.png" alt="" />
                            </div>
                        </>
                    )}
                </div>
            </Chip>
        </div>
    );
};

DramaGags.propTypes = {
    content: PropTypes.array,
    dramaGagsTitleImage: PropTypes.string,
};

export default errorBoundary(DramaGags);
